import { createElement } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { FileText, Users, CreditCard, Shield, AlertTriangle, Scale, Ban, RefreshCw } from "lucide-react";

const sections = [
  {
    icon: FileText,
    title: "1. Aceitação dos Termos",
    content: [
      {
        subtitle: "1.1 Acordo Vinculante",
        text: "Ao acessar ou usar a plataforma AROAN, você concorda em ficar vinculado a estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não deverá usar nossos serviços.",
        items: [],
      },
      {
        subtitle: "1.2 Capacidade Legal",
        text: "Você declara que:",
        items: [
          "Tem pelo menos 18 anos de idade ou a maioridade legal em sua jurisdição",
          "Possui autoridade legal para celebrar contratos vinculativos",
          "Não está proibido de usar nossos serviços por qualquer lei aplicável",
          "Se representar uma empresa, tem autoridade para vincular essa entidade a estes termos",
        ],
      },
      {
        subtitle: "1.3 Alterações nos Termos",
        text: "Reservamos o direito de modificar estes termos a qualquer momento. Notificaremos você sobre alterações significativas com pelo menos 30 dias de antecedência. O uso continuado após as alterações constituirá aceitação dos novos termos.",
        items: [],
      },
    ],
  },
  {
    icon: Users,
    title: "2. Contas e Acesso",
    content: [
      {
        subtitle: "2.1 Criação de Conta",
        text: "Para usar a plataforma AROAN, você deve:",
        items: [
          "Fornecer informações precisas, completas e atualizadas",
          "Manter a segurança de sua senha e credenciais de acesso",
          "Notificar-nos imediatamente sobre qualquer uso não autorizado",
          "Ser responsável por todas as atividades que ocorrem em sua conta",
        ],
      },
      {
        subtitle: "2.2 Contas Empresariais",
        text: "Para contas empresariais:",
        items: [
          "O administrador da conta tem controle total sobre usuários e permissões",
          "A empresa é responsável por todas as ações de seus usuários",
          "Múltiplos usuários podem ser adicionados conforme o plano contratado",
          "Você deve manter informações de faturamento atualizadas",
        ],
      },
      {
        subtitle: "2.3 Suspensão ou Encerramento",
        text: "Podemos suspender ou encerrar sua conta se:",
        items: [
          "Houver violação destes Termos de Uso",
          "Houver suspeita de fraude ou atividade ilegal",
          "Houver falta de pagamento por mais de 15 dias",
          "Você solicitar o encerramento da conta",
          "For necessário para proteger a segurança da plataforma",
        ],
      },
    ],
  },
  {
    icon: CreditCard,
    title: "3. Planos, Preços e Pagamento",
    content: [
      {
        subtitle: "3.1 Planos de Assinatura",
        text: "AROAN oferece diferentes planos de assinatura:",
        items: [
          "Essentials: até 50 usuários com recursos básicos",
          "Professional: 50-200 usuários com recursos avançados",
          "Enterprise: 200+ usuários com personalização completa",
          "Preços são cobrados mensalmente com base no número de usuários",
        ],
      },
      {
        subtitle: "3.2 Faturamento",
        text: "Termos de faturamento:",
        items: [
          "Cobranças recorrentes processadas automaticamente no início de cada período",
          "Preços em Reais (BRL), exceto se acordado diferentemente",
          "Impostos aplicáveis serão adicionados conforme a lei",
          "Notas fiscais emitidas automaticamente e disponíveis na plataforma",
          "Pagamentos aceitos via cartão de crédito, boleto ou transferência bancária",
        ],
      },
      {
        subtitle: "3.3 Reajustes de Preço",
        text: "Podemos reajustar preços anualmente:",
        items: [
          "Notificação com pelo menos 30 dias de antecedência",
          "Reajustes não superiores ao IPCA ou índice equivalente",
          "Você pode cancelar antes do reajuste entrar em vigor",
          "Clientes com contratos anuais mantêm preço pelo período contratado",
        ],
      },
      {
        subtitle: "3.4 Período de Teste",
        text: "Oferecemos período de teste gratuito:",
        items: [
          "14 dias para avaliar a plataforma sem compromisso",
          "Acesso completo aos recursos do plano escolhido",
          "Não é necessário cartão de crédito para iniciar o teste",
          "Dados são mantidos por 30 dias após término do teste",
          "Apenas um período de teste por empresa",
        ],
      },
      {
        subtitle: "3.5 Cancelamento e Reembolsos",
        text: "Política de cancelamento:",
        items: [
          "Cancelamento pode ser feito a qualquer momento sem multa",
          "Acesso mantido até o fim do período pago",
          "Não oferecemos reembolsos proporcionais, exceto em casos específicos",
          "Reembolso integral se cancelar dentro de 7 dias da primeira cobrança",
          "Reembolso pode ser oferecido em caso de falha grave do serviço",
        ],
      },
    ],
  },
  {
    icon: Shield,
    title: "4. Uso Aceitável",
    content: [
      {
        subtitle: "4.1 Uso Permitido",
        text: "Você pode usar AROAN para:",
        items: [
          "Gerenciar chamados, tickets e solicitações de serviço",
          "Automatizar processos e fluxos de trabalho empresariais",
          "Criar e gerenciar formulários e pesquisas",
          "Integrar com outros sistemas e ferramentas empresariais",
          "Analisar dados e gerar relatórios de performance",
        ],
      },
      {
        subtitle: "4.2 Uso Proibido",
        text: "Você NÃO pode usar AROAN para:",
        items: [
          "Violar leis, regulamentos ou direitos de terceiros",
          "Transmitir malware, vírus ou código malicioso",
          "Realizar engenharia reversa ou tentar acessar código-fonte",
          "Sobrecarregar ou tentar comprometer a segurança da plataforma",
          "Revender ou sublicenciar acesso sem autorização expressa",
          "Coletar dados de outros usuários sem consentimento",
          "Usar para spam, phishing ou atividades fraudulentas",
          "Armazenar ou processar conteúdo ilegal ou ofensivo",
        ],
      },
      {
        subtitle: "4.3 Limites de Uso",
        text: "Limites técnicos por plano:",
        items: [
          "Número de usuários conforme plano contratado",
          "Armazenamento de dados conforme especificação do plano",
          "Limites de requisições de API para prevenir abuso",
          "Tamanho máximo de arquivos individuais: 100MB",
          "Podemos impor limites adicionais para proteger a plataforma",
        ],
      },
    ],
  },
  {
    icon: FileText,
    title: "5. Propriedade Intelectual",
    content: [
      {
        subtitle: "5.1 Propriedade da AROAN",
        text: "AROAN e todos os seus componentes são de propriedade exclusiva da AROAN:",
        items: [
          "Software, código-fonte e algoritmos",
          "Interface de usuário, design e elementos visuais",
          "Marca AROAN, logos e identidade visual",
          "Documentação, tutoriais e materiais de treinamento",
          "Tecnologia VIA e modelos de IA proprietários",
        ],
      },
      {
        subtitle: "5.2 Licença de Uso",
        text: "Concedemos a você uma licença limitada, não exclusiva, intransferível para:",
        items: [
          "Acessar e usar a plataforma conforme estes termos",
          "Número de usuários conforme plano contratado",
          "Licença válida enquanto sua assinatura estiver ativa",
          "Licença pode ser revogada em caso de violação dos termos",
        ],
      },
      {
        subtitle: "5.3 Seus Dados",
        text: "Você mantém propriedade sobre seus dados:",
        items: [
          "Você é o proprietário de todos os dados que insere na plataforma",
          "Concede-nos licença para processar seus dados conforme necessário",
          "Podemos usar dados agregados e anonimizados para melhorias",
          "Você pode exportar seus dados a qualquer momento",
          "Excluímos seus dados conforme nossa Política de Privacidade",
        ],
      },
      {
        subtitle: "5.4 Feedback e Sugestões",
        text: "Ao fornecer feedback:",
        items: [
          "Você nos concede direitos perpétuos e irrevogáveis sobre o feedback",
          "Podemos usar suas sugestões sem compensação ou atribuição",
          "Feedback não é considerado informação confidencial",
          "Não somos obrigados a implementar nenhuma sugestão",
        ],
      },
    ],
  },
  {
    icon: AlertTriangle,
    title: "6. Garantias e Responsabilidades",
    content: [
      {
        subtitle: "6.1 Disponibilidade do Serviço",
        text: "Nos esforçamos para manter alta disponibilidade:",
        items: [
          "Meta de uptime de 99.9% para planos Professional e Enterprise",
          "Manutenções programadas notificadas com 48 horas de antecedência",
          "Não garantimos operação ininterrupta ou livre de erros",
          "Não somos responsáveis por problemas de conectividade de terceiros",
        ],
      },
      {
        subtitle: "6.2 Limitação de Garantias",
        text: "O serviço é fornecido 'como está':",
        items: [
          "Não garantimos que o serviço atenderá todos os seus requisitos",
          "Não garantimos resultados específicos do uso da plataforma",
          "Você é responsável por avaliar a adequação para seu uso",
          "Recomendamos manter backups independentes de dados críticos",
        ],
      },
      {
        subtitle: "6.3 Limitação de Responsabilidade",
        text: "Nossa responsabilidade é limitada:",
        items: [
          "Responsabilidade máxima limitada ao valor pago nos últimos 12 meses",
          "Não somos responsáveis por danos indiretos, incidentais ou consequenciais",
          "Não somos responsáveis por perda de lucros, receitas ou dados",
          "Limitações não se aplicam em casos de dolo ou culpa grave",
          "Algumas jurisdições não permitem limitações; consulte leis locais",
        ],
      },
      {
        subtitle: "6.4 Indenização",
        text: "Você concorda em nos indenizar contra:",
        items: [
          "Reclamações decorrentes do seu uso da plataforma",
          "Violação destes termos ou leis aplicáveis",
          "Violação de direitos de terceiros",
          "Conteúdo que você enviar ou compartilhar na plataforma",
        ],
      },
    ],
  },
  {
    icon: Ban,
    title: "7. Rescisão",
    content: [
      {
        subtitle: "7.1 Rescisão por Você",
        text: "Você pode encerrar sua conta a qualquer momento:",
        items: [
          "Através do painel de administração na plataforma",
          "Entrando em contato com nosso suporte",
          "Acesso mantido até o fim do período pago",
          "Dados mantidos por 30 dias após rescisão para recuperação",
          "Após 30 dias, dados são permanentemente excluídos",
        ],
      },
      {
        subtitle: "7.2 Rescisão por Nós",
        text: "Podemos encerrar sua conta imediatamente se:",
        items: [
          "Houver violação material destes termos",
          "Houver atividade fraudulenta ou ilegal",
          "Houver risco à segurança da plataforma ou outros usuários",
          "Não houver pagamento por mais de 30 dias",
          "For necessário para cumprir obrigações legais",
        ],
      },
      {
        subtitle: "7.3 Efeitos da Rescisão",
        text: "Após rescisão:",
        items: [
          "Seu acesso à plataforma é imediatamente suspenso",
          "Você permanece responsável por pagamentos devidos até a rescisão",
          "Disposições que devem sobreviver continuam em vigor",
          "Podemos reter dados conforme exigido por lei",
        ],
      },
    ],
  },
  {
    icon: Scale,
    title: "8. Disposições Gerais",
    content: [
      {
        subtitle: "8.1 Lei Aplicável",
        text: "Estes termos são regidos pelas leis do Brasil:",
        items: [
          "Legislação brasileira aplicável sem considerar conflitos de leis",
          "Foro da comarca de São Paulo, SP para resolver disputas",
          "Você renuncia a qualquer objeção ao foro escolhido",
          "Podemos buscar medidas cautelares em qualquer jurisdição",
        ],
      },
      {
        subtitle: "8.2 Resolução de Disputas",
        text: "Em caso de disputas:",
        items: [
          "Primeiro, tentaremos resolver amigavelmente",
          "Prazo de 30 dias para negociação de boa-fé",
          "Se não resolver, você pode recorrer ao Procon ou tribunais",
          "Podemos buscar arbitragem conforme câmara especializada",
        ],
      },
      {
        subtitle: "8.3 Integralidade do Acordo",
        text: "Estes termos constituem o acordo completo:",
        items: [
          "Substituem todos os acordos anteriores sobre o assunto",
          "Podem ser complementados por contratos específicos",
          "Anexos e políticas referenciadas fazem parte dos termos",
          "Alterações devem ser feitas por escrito",
        ],
      },
      {
        subtitle: "8.4 Divisibilidade",
        text: "Se qualquer disposição for considerada inválida:",
        items: [
          "Apenas essa disposição será removida ou modificada",
          "Demais disposições permanecem em pleno vigor",
          "Disposição inválida será interpretada para refletir intenção original",
        ],
      },
      {
        subtitle: "8.5 Cessão",
        text: "Sobre transferência de direitos:",
        items: [
          "Você não pode transferir seus direitos sem nossa aprovação prévia",
          "Podemos transferir nossos direitos para afiliadas ou sucessores",
          "Notificaremos você sobre transferências significativas",
        ],
      },
      {
        subtitle: "8.6 Renúncia",
        text: "Nossa tolerância não constitui renúncia:",
        items: [
          "Não aplicar um termo não significa renunciar ao direito de aplicá-lo depois",
          "Renúncias devem ser expressas e por escrito",
          "Renúncia de um direito não implica renúncia de outros",
        ],
      },
      {
        subtitle: "8.7 Força Maior",
        text: "Não somos responsáveis por eventos fora de nosso controle:",
        items: [
          "Desastres naturais, guerras, terrorismo",
          "Falhas de infraestrutura de internet ou energia",
          "Atos governamentais ou mudanças regulatórias",
          "Greves, lockouts ou outros distúrbios trabalhistas",
          "Obrigações são suspensas durante eventos de força maior",
        ],
      },
    ],
  },
];

const TermosDeUso = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Termos de Uso"
        description="Termos e condições de uso da plataforma Aroan: contratação, período de avaliação, responsabilidades, pagamentos e cancelamento."
        canonical="https://aroan.com.br/termos-de-uso"
        ogType="website"
        article={false}
      />
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-12 bg-gradient-hero overflow-hidden">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6 animate-fade-in">
              <Scale className="w-4 h-4 text-primary" />
              <span className="text-sm font-semibold text-primary">Termos de Uso</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight animate-fade-in-delay-1">
              Termos e Condições de{" "}
              <span className="text-primary">Uso da AROAN</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-muted-foreground mb-4 animate-fade-in-delay-2">
              Última atualização: 10 de novembro de 2025
            </p>
            
            <p className="text-base text-muted-foreground max-w-3xl mx-auto animate-fade-in-delay-3">
              Estes Termos de Uso estabelecem as condições para acesso e utilização da plataforma AROAN. 
              Por favor, leia atentamente antes de usar nossos serviços.
            </p>
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section className="py-8 bg-primary/5 border-y border-primary/20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-start gap-4 p-6 bg-card rounded-xl border border-primary/30">
              <AlertTriangle className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-lg mb-2">Importante</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Ao criar uma conta ou usar a plataforma AROAN, você concorda automaticamente com 
                  todos os termos e condições descritos neste documento. Se você não concordar com 
                  qualquer parte, por favor não utilize nossos serviços.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Table of Contents */}
      <section className="py-12 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-6">Índice</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              {sections.map((section, index) => (
                <a
                  key={index}
                  href={`#section-${index}`}
                  className="flex items-center gap-3 p-4 rounded-xl bg-card border border-border hover:border-primary/50 hover:shadow-md transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    {createElement(section.icon, { className: "w-5 h-5 text-primary" })}
                  </div>
                  <span className="font-medium text-sm">{section.title}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto space-y-16">
            {sections.map((section, index) => {
              const Icon = section.icon;
              return (
                <div
                  key={index}
                  id={`section-${index}`}
                  className="animate-fade-in scroll-mt-24"
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <div className="flex items-start gap-4 mb-8">
                    <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-7 h-7 text-primary" />
                    </div>
                    <div>
                      <h2 className="text-3xl font-bold mb-2">{section.title}</h2>
                    </div>
                  </div>

                  <div className="space-y-8 pl-0 md:pl-18">
                    {section.content.map((subsection, subIndex) => (
                      <div key={subIndex} className="bg-card rounded-2xl border border-border p-8">
                        {subsection.subtitle && (
                          <h3 className="text-xl font-semibold mb-3">
                            {subsection.subtitle}
                          </h3>
                        )}
                        {subsection.text && (
                          <p className="text-muted-foreground mb-4 leading-relaxed">
                            {subsection.text}
                          </p>
                        )}
                        {subsection.items.length > 0 && (
                          <ul className="space-y-3">
                            {subsection.items.map((item, itemIndex) => (
                              <li key={itemIndex} className="flex items-start gap-3">
                                <div className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-2" />
                                <span className="text-muted-foreground leading-relaxed">
                                  {item}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-gradient-to-br from-primary/5 to-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-card rounded-2xl border border-border p-8 md:p-12">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <FileText className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold mb-2">
                    Dúvidas Sobre os Termos?
                  </h2>
                  <p className="text-muted-foreground">
                    Nossa equipe jurídica está disponível para esclarecer qualquer questão
                  </p>
                </div>
              </div>

              <div className="space-y-4 bg-accent/50 rounded-xl p-6">
                <div className="flex items-start gap-3">
                  <FileText className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold mb-1">Departamento Jurídico</p>
                    <a 
                      href="mailto:juridico@aroan.com" 
                      className="text-primary hover:underline"
                    >
                      juridico@aroan.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <Users className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold mb-1">Suporte ao Cliente</p>
                    <a 
                      href="mailto:suporte@aroan.com" 
                      className="text-primary hover:underline"
                    >
                      suporte@aroan.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <RefreshCw className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold mb-1">Atualizações</p>
                    <p className="text-muted-foreground">
                      Você será notificado por email sobre alterações significativas nos termos
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-border">
                <h3 className="font-semibold mb-4">Documentos Relacionados</h3>
                <div className="flex flex-wrap gap-3">
                  <a 
                    href="/privacidade" 
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 hover:bg-primary/20 text-primary transition-colors"
                  >
                    <Shield className="w-4 h-4" />
                    Política de Privacidade
                  </a>
                  <a 
                    href="#" 
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 hover:bg-primary/20 text-primary transition-colors"
                  >
                    <FileText className="w-4 h-4" />
                    SLA e Níveis de Serviço
                  </a>
                  <a 
                    href="#" 
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 hover:bg-primary/20 text-primary transition-colors"
                  >
                    <CreditCard className="w-4 h-4" />
                    Política de Pagamento
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermosDeUso;
